import { checkErrorDniFormat } from '@chilecompra/react-kit'
import { CLEAN_DNI } from '../../config/settings/regexes'

/**
 * To clean a value that is formatted as a Chilean DNI.
 * Returns the given value without points and hyphen.
 */
export const cleanDNI = value => {
  return typeof value === 'string' ? value.replace(CLEAN_DNI, '').toUpperCase() : ''
}

/**
 * To check if a DNI corresponds to a natural person or not.
 * This implementation is momentary.
 */
export const isNaturalPerson = value => {
  value = cleanDNI(value?.toString())
  const dni = value.substring(0, value.length - 1)

  return parseInt(dni, 10) < 50000000
}

/**
 * To check if the given value corresponds to a foreign seller.
 */
export const checkIfForeignDni = value => !checkErrorDniFormat(value)

/**
 * To get the last Sunday.
 */
export const getLastSunday = () => {
  const now = new Date()
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
  return new Date(today.setDate(today.getDate() - today.getDay()))
}
